<template>
  <main
    :class="useRoute().meta?.fillHeight ? 'FillHeight' : ''"
  >
    <div
      v-if="useRoute().meta?.lightBackground"
      class="layout-fixed-bg bg-light"
    />

    <AppHeaderRestricted v-if="useAuthStore().isRestrictedAdmin" />
    <AppHeaderAdmin v-else />

    <slot />

    <!-- global dialogs -->
    <ConfirmEmergencyDialog />
  </main>
</template>

<script setup>
onMounted(() => {
  useNuxtApp().$store.dispatch('requests/getRequestStates');
  // Restricted admins are not operators; skip the staff-only operators fetch (would 403).
  if (!useAuthStore().isRestrictedAdmin) {
    useNuxtApp().$store.dispatch('operator/operators/getOperators');
  }
});
</script>

<style scoped>
main {
  &.FillHeight {
    padding-bottom: 0;
    height: 100vh;
    overflow: hidden;

    display: flex;
    flex-direction: column;
  }
}
</style>
